module.exports = __webpack_public_path__ + "static/img/7.8be28ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/history/hospital/7.png
// module id = bduv
// module chunks = 1